import { render, staticRenderFns } from "./ComplianceSeverity.vue?vue&type=template&id=25886d40&scoped=true"
import script from "./ComplianceSeverity.vue?vue&type=script&lang=js"
export * from "./ComplianceSeverity.vue?vue&type=script&lang=js"
import style0 from "./ComplianceSeverity.vue?vue&type=style&index=0&id=25886d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25886d40",
  null
  
)

export default component.exports